import DetailUserLeave from '@/requests/leaves/views/user/detailtLeave';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/requests/viewLeave/$id/detailLeaveUser',
)({
  component: LeaveDetailUserPage,
})

function LeaveDetailUserPage() {
  const { id } = Route.useParams();
  return <DetailUserLeave leaveId={id} />
}